class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    if (document.querySelector('#CartDrawer-Overlay')) document.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    if (document.querySelector('.cart__close-btn')) document.querySelector('.cart__close-btn').addEventListener('click', this.close.bind(this));
    if (document.querySelector('.cart-empty__btn')) document.querySelector('.cart-empty__btn').addEventListener('click', this.close.bind(this));
    if (document.querySelector('.cart-related')) {        
        document.querySelector('.cart-related').addEventListener("click", e => {
            if (e.target.closest('.list-product__add-to-cart')) this.buyOneClick(e);
        })
    }
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    // this.addEventListener(
    //   'transitionend',
    //   () => {
    //     const containerToTrapFocusOn = this.classList.contains('is-empty')
    //       ? this.querySelector('.drawer__inner-empty')
    //       : document.getElementById('CartDrawer');
    //     const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
    //     trapFocus(containerToTrapFocusOn, focusElement);
    //   },
    //   { once: true }
    // );

    document.body.classList.add('lock');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('lock');
  }

  addOneClick = (productVariantId) => {

    let formData = {
        'items': [{
            'id': productVariantId,
            'quantity': 1
        }],
        'sections': this.getSectionsToRender().map((section) => section.id)
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    }).then(r => r.json()).then(r => {
        
        publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: productVariantId,
            cartData: r,
        });

        this.error = false;
        // this.cart.renderContents(r);

    })
  }

  buyOneClick = (e) => {
    const dataProduct = e.target.dataset.variant;
    if (dataProduct) this.addOneClick(dataProduct);
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.cart-content').classList.contains('is-empty') && this.querySelector('.cart-content').classList.remove('is-empty');
    
    this.productId = parsedState.id;

    // this.getSectionsToRender().forEach((section) => {
    //   const sectionElement = section.selector
    //     ? document.querySelector(section.selector)
    //     : document.getElementById(section.id);        
    //   if (!sectionElement) return;
    //   sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    // });

            
    this.getSectionsToRender().forEach((section) => {       

        const elementToReplace = document.getElementById(section.id);
        
        if (elementToReplace) {
            if (section.id === 'CartDrawer') {
                const cartItemsToReplace = document.querySelector('#CartDrawer-CartItems');

                cartItemsToReplace.innerHTML = this.getSectionInnerHTML(
                    parsedState.sections[section.id],
                    '#CartDrawer-CartItems'
                );
            } else {
                elementToReplace.innerHTML = this.getSectionInnerHTML(
                    parsedState.sections[section.id],
                    section.selector
                );
                const addedValue = Number.parseInt(document.querySelector('.quant-block--type_in-page .quant-block__input').value);

                if (document.querySelector('.cart__title')) {
                    const prevItemCountmatches = document.querySelector('.cart__title').textContent.match(/\d+/);

                    
                    if (prevItemCountmatches && prevItemCountmatches.length > 0) {
                        const prevProductsCount = Number.parseInt(prevItemCountmatches[0]);
                        
                        if (prevProductsCount && addedValue) document.querySelector('.cart__title').textContent = `Cart(${prevProductsCount + addedValue})`
                    } else {
                        document.querySelector('.cart__title').textContent = `Cart(${addedValue})`;
                    }
                }

                
            }

        }
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.cart__drawer',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


if (Array.from(document.querySelectorAll('#relatedCartSlider')).length > 0) {

    Array.from(document.querySelectorAll('#relatedCartSlider')).forEach(sl => {
        new Swiper(sl.querySelector('.swiper'), {
            slidesPerView: 2,
            loop: true,
            navigation: {
                prevEl: sl.querySelector('.swiper-btn-prev'),
                nextEl: sl.querySelector('.swiper-btn-next'),
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                },
                961: {
                    slidesPerView: 2,
                }
            }
        })
    })
}


if (document.querySelector('.accordion')) {
    Array.from(document.querySelectorAll('.accordion')).forEach(acc => {
        acc.querySelector('.accordion__heading').addEventListener("click", e => {
            if (!acc.classList.contains('active') && document.querySelector('.accordion.active')) {
                document.querySelector('.accordion.active').classList.remove('active');
            }
            acc.classList.toggle('active');
        })
    })
}